<template>
  <div class="product-card">
    <a class="product-card__link" :href="link"></a>
    <div class="product-card__label">
      <div v-if="info.DISCOUNT_PERCENT" class="product-card__label-item">Скидка {{ info.DISCOUNT_PERCENT }}%</div>
      <div v-if="info.NEW === 'Y'" class="product-card__label-item new">Новинка</div>
    </div>
    <div class="product-card__favorite" :class="{'active': isFav}" @click="addToFavs"></div>
    <div class="product-card__img" :class="{'filled': info.PICTURE || info.PICTURE_MOBILE}">
      <picture>
        <source media="(min-width: 768px)" :srcset="info.PICTURE ? info.PICTURE : ''">
        <source media="(max-width: 767px)" :srcset="info.PICTURE_MOBILE ? info.PICTURE_MOBILE : ''">
        <img :alt="info.IMG_DESCR ? info.IMG_DESCR : 'Изображение'" loading="lazy">
      </picture>
    </div>
    <div class="product-card__title">{{ info.NAME }}</div>
    <div class="product-card__description">{{ info.PREVIEW_TEXT }}</div>
    <div class="product-card__bottom">
      <div class="product-card__price">
        <div class="product-card__price-new" v-html="info.PRICE ? new Intl.NumberFormat('ru-RU').format(Number(info.PRICE)) + ' ₽' : ''"></div>
        <div v-if="info.PRICE !== info.OLD_PRICE" v-html="info.OLD_PRICE ? new Intl.NumberFormat('ru-RU').format(Number(info.OLD_PRICE)) + ' ₽' : ''" class="product-card__price-old"></div>
      </div>

      <div class="product-card__buttons">
        <div class="product-card__marketplaces" v-if="marketplaces?.length">
          <component
            :is="marketplace.link ? 'a' : 'span'"
            v-for="marketplace in marketplaces"
            :key="marketplace.name"
            :href="marketplace.link"
            :target="marketplace.link ? '_blank' : null"
            :title="marketplace.name"
            class="product-card__marketplace"
            :class="{'product-card__marketplace--split': marketplace.name === 'Яндекс Сплит'}"
          >
            <img
              :src="marketplace.logo"
              :alt="marketplace.name"
              class="product-card__marketplace-logo"
            >
          </component>
        </div>
        <div v-if="info.AV_QUANTITY === '0' || !info.AV_QUANTITY" class="product-card__empty">Нет в наличии</div>
        <div v-else-if="inBasket" class="product-card__basket" :class="{'active': inBasket}">
          <a class="product-card__basket-link" href="/basket/" title="Перейти в корзину"></a>
        </div>
        <div v-else class="product-card__basket" @click="addToBasket"></div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState, mapActions} from "vuex";

export default {
  name : "CatalogItem",
  props : {
    info: Object,
    marketplaces: Array,
  },
  data()
  {
    return {
      quantity : 1,
      link     : ""
    };
  },
  computed : {
    ...mapState([
      "moduleBasket", "moduleFavorites"
    ]),
    isFav()
    {
      for(let fav in this.moduleFavorites.favorites)
        if(parseInt(this.moduleFavorites.favorites[fav].ID) === parseInt(this.info.ID))
        {
          return true;
        }
      return false;
    },
    inBasket()
    {
      for(let fav in this.moduleBasket.basket)
        if(parseInt(this.moduleBasket.basket[fav].PRODUCT_ID) === parseInt(this.info.ID))
        {
          return true;
        }
      return false;
    }
  },
  methods  : {
    ...mapActions([
      "ADD_BASKET_ITEM", "ADD_FAVS_ITEM", "DEL_FAVS_ITEM"
    ]),
    addToBasket()
    {
      this.ADD_BASKET_ITEM({
        id       : this.info.ID,
        quantity : this.quantity
      });
    },
    addToFavs()
    {
      if(this.isFav)
      {
        this.DEL_FAVS_ITEM(this.info.ID);
      }
      else
      {
        this.ADD_FAVS_ITEM(this.info);
      }
    }
  },
  created()
  {
    if(this.info.URL)
    {
      this.link = this.info.URL;
    }
    if(this.info.DETAIL_PAGE_URL)
    {
      this.link = this.info.DETAIL_PAGE_URL;
    }
  }
};
</script>